// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__92bL-","placeholderImage":"styles_placeholderImage__7Uj0W"};